import { Grid } from "@material-ui/core";
import { Permission } from "../../components/permission";
import { ResetPassword } from "./change-password";
import { Crypto } from "./crypto";
import { LangaugePicker } from "./language-picker";
import { Marketing } from "./marketing";
import { MerchantServices } from "./merchant-services";

export const SettingsPage = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Grid container spacing={3} direction="column">
          <Grid item xs={12} md={12}>
            <LangaugePicker />
          </Grid>
          <Permission roles={["ROLE_USER"]}>
            <Grid item xs={12} md={12}>

              <Marketing />
            </Grid>
          </Permission>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <ResetPassword />
      </Grid>

      <Permission roles={["ROLE_MERCHANT"]}>
        <Grid item xs={12} md={6}>
          <MerchantServices />
        </Grid>
      </Permission>
    </Grid>
  );
};
